export default class WidgetGeneralFooterCtrl {
  onClick(isPrev) {
    const currentData = { clicked: this.selectedTitle };
    isPrev && this.onPreviousClick(currentData);
    !isPrev && this.onNextClick(currentData);
  }
}
